(function() {
   'use strict';

    angular
        .module('MW.CoreStream.CsSelectDropDown', [])
        .directive('csSelectDropDown', function() {
            return {
                restrict: 'E',
                scope: {
                    toggleSelectAll: '&',
                    selectAll: '&',
                    deselectAll: '&',
                    allSelected: '='
                },
                templateUrl: 'icm-web/views/partials/cs_select_drop_down',
                link: function(scope) {
                    scope.arrowLabel = '<label class="icon-arrow-down"></label>';

                    //This will close the dropdown menu once an item is selected.
                    scope.sendToggleDropdownEvent = function sendToggleDropdownEvent() {
                        scope.$broadcast('toggleDropdownMenuDirective', {
                            menuName: 'selectAll',
                            bool: false
                        });
                    };
                }
            };
        });
} ());